



 import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
 import AgroGenericCard from "@/components/agroGenericCard/AgroGenericCard.vue";
 import * as analysesApi from "@/api/analyses";
 import { AnalysesCount } from "@/api/analyses/types";

 @Component({
   name: 'CardAnalysesCountController',
   components: {
     AgroGenericCard,
   }
 })

export default class CardAnalysesCountController extends Vue {
  private isLoading = false;
  private count: number | null = null;
  private analysisType: string | null = null;

  @Prop({ type: Boolean, default: false }) private onlyUserFarms!: boolean;
  @Prop({ type: Boolean, default: false }) private isRemovedFarm!: boolean;
  

  async mounted() {
    this.analysisType = 'ANALITICA';
    await this.getAnalysesCount();
  };

  @Watch('onlyUserFarms')
  @Watch('isRemovedFarm')
  private async getAnalysesCount() {
    this.isLoading = true;
    try {
      const response = (await analysesApi.getAnalysesCount(this.analysisType!, this.onlyUserFarms)).data;
      this.count = response.value;
    } catch {
      this.count = null;
    } finally {
      this.isLoading = false;
    }
  }
  
}
